var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "div",
                { staticClass: "page-header-bar" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", icon: "el-icon-back" },
                      on: { click: _vm.goBack },
                    },
                    [_vm._v("返回")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "page-title" }, [
                    _vm._v(
                      _vm._s(_vm.$route.params.id ? "编辑商品" : "新增商品")
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.stepInput
                ? _c(
                    "el-steps",
                    {
                      attrs: {
                        active: _vm.currentTab,
                        "align-center": "",
                        "finish-status": "success",
                      },
                    },
                    [
                      _c("el-step", { attrs: { title: "商品信息" } }),
                      _vm._v(" "),
                      _c("el-step", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.customConfig.mallType == 1,
                            expression: "customConfig.mallType==1",
                          },
                        ],
                        attrs: { title: "商品详情" },
                      }),
                      _vm._v(" "),
                      _c("el-step", { attrs: { title: "其他设置" } }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.fullscreenLoading,
                  expression: "fullscreenLoading",
                },
              ],
              ref: "formValidate",
              staticClass: "formValidate mt20",
              attrs: {
                rules: _vm.ruleValidate,
                model: _vm.formValidate,
                "label-width": "120px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab === 0,
                      expression: "currentTab === 0",
                    },
                  ],
                  attrs: { gutter: 24 },
                },
                [
                  _vm.customConfig.mallType == 2
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "录入商品类型：",
                            props: "printInputType",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: _vm.formValidate.id != 0 },
                              on: {
                                change: function ($event) {
                                  return _vm.onChangePrintInputType(
                                    _vm.printInputType
                                  )
                                },
                              },
                              model: {
                                value: _vm.printInputType,
                                callback: function ($$v) {
                                  _vm.printInputType = $$v
                                },
                                expression: "printInputType",
                              },
                            },
                            [
                              _c(
                                "el-radio",
                                { staticClass: "radio", attrs: { label: 1 } },
                                [_vm._v("打印")]
                              ),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("装订"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.customConfig.mallType == 1
                    ? _c(
                        "el-col",
                        _vm._b({}, "el-col", _vm.grid2, false),
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "商品分类：", prop: "cateIds" } },
                            [
                              _c("el-cascader", {
                                staticClass: "selWidth",
                                attrs: {
                                  options: _vm.merCateList,
                                  props: _vm.props2,
                                  clearable: "",
                                  "show-all-levels": false,
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value: _vm.formValidate.cateIds,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formValidate, "cateIds", $$v)
                                  },
                                  expression: "formValidate.cateIds",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.customConfig.mallType == 2
                    ? _c(
                        "el-col",
                        _vm._b({}, "el-col", _vm.grid2, false),
                        [
                          _vm.printInputType == 1
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "商品分类：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "mr20",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: "请选择",
                                        disabled: _vm.isDisabled,
                                      },
                                      on: { change: _vm.change },
                                      model: {
                                        value: _vm.currentPrintCategoryId,
                                        callback: function ($$v) {
                                          _vm.currentPrintCategoryId = $$v
                                        },
                                        expression: "currentPrintCategoryId",
                                      },
                                    },
                                    _vm._l(
                                      _vm.printCategoryPaperList,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.name,
                                            value: item.id,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.printInputType == 2
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "商品分类：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "mr20",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: "请选择",
                                        disabled: _vm.isDisabled,
                                      },
                                      on: { change: _vm.change },
                                      model: {
                                        value: _vm.currentPrintCategoryId,
                                        callback: function ($$v) {
                                          _vm.currentPrintCategoryId = $$v
                                        },
                                        expression: "currentPrintCategoryId",
                                      },
                                    },
                                    _vm._l(
                                      _vm.printCategoryWrapperList,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.name,
                                            value: item.id,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid2, false),
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品名称：", prop: "storeName" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "249",
                              placeholder: "请输入商品名称",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formValidate.storeName,
                              callback: function ($$v) {
                                _vm.$set(_vm.formValidate, "storeName", $$v)
                              },
                              expression: "formValidate.storeName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid2, false),
                    [
                      _vm.customConfig.mallType == 1
                        ? _c(
                            "el-form-item",
                            {
                              attrs: { label: "商品关键字：", prop: "keyword" },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入商品关键字",
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value: _vm.formValidate.keyword,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formValidate, "keyword", $$v)
                                  },
                                  expression: "formValidate.keyword",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.customConfig.mallType == 2 && _vm.printInputType == 1
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "打印纸张：", prop: "keyword" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入打印纸张",
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value: _vm.formValidate.keyword,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formValidate, "keyword", $$v)
                                  },
                                  expression: "formValidate.keyword",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.printInputType == 2 && _vm.customConfig.mallType == 2
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "装订方式：", prop: "keyword" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder:
                                    "请输入装订方式（例如：骑马钉、精装）",
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value: _vm.formValidate.keyword,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formValidate, "keyword", $$v)
                                  },
                                  expression: "formValidate.keyword",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.customConfig.mallType == 1
                    ? _c(
                        "el-col",
                        _vm._b({}, "el-col", _vm.grid2, false),
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "单位：", prop: "unitName" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入单位",
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value: _vm.formValidate.unitName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formValidate, "unitName", $$v)
                                  },
                                  expression: "formValidate.unitName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.customConfig.mallType == 1
                    ? _c(
                        "el-col",
                        _vm._b({}, "el-col", _vm.grid2, false),
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "商品简介：", prop: "storeInfo" },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  maxlength: "250",
                                  rows: 3,
                                  placeholder: "请输入商品简介",
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value: _vm.formValidate.storeInfo,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formValidate, "storeInfo", $$v)
                                  },
                                  expression: "formValidate.storeInfo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { xs: 18, sm: 18, md: 18, lg: 12, xl: 12 } },
                    [
                      _vm.customConfig.mallType == 1
                        ? _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "商品封面图：",
                                        prop: "image",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "upLoadPicBox",
                                          attrs: { disabled: _vm.isDisabled },
                                          on: {
                                            click: function ($event) {
                                              return _vm.modalPicTap("1")
                                            },
                                          },
                                        },
                                        [
                                          _vm.formValidate.image
                                            ? _c(
                                                "div",
                                                { staticClass: "pictrue" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.formValidate
                                                        .image,
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _c(
                                                "div",
                                                { staticClass: "upLoad" },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-camera cameraIconfont",
                                                  }),
                                                ]
                                              ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        "label-width": "180",
                                        label: "商品竖版海报图：",
                                        prop: "verticalPosterImage",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "upLoadPicBox",
                                          attrs: { disabled: _vm.isDisabled },
                                          on: {
                                            click: function ($event) {
                                              return _vm.modalPicTapPoster()
                                            },
                                          },
                                        },
                                        [
                                          _vm.formValidate.verticalPosterImage
                                            ? _c(
                                                "div",
                                                { staticClass: "pictrue" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.formValidate
                                                        .verticalPosterImage,
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _c(
                                                "div",
                                                { staticClass: "upLoad" },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-camera cameraIconfont",
                                                  }),
                                                ]
                                              ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.customConfig.mallType == 1
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "商品轮播图：",
                                prop: "sliderImages",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "acea-row" },
                                [
                                  _vm._l(
                                    _vm.formValidate.sliderImages,
                                    function (item, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "pictrue",
                                          attrs: { draggable: "true" },
                                          on: {
                                            dragstart: function ($event) {
                                              return _vm.handleDragStart(
                                                $event,
                                                item
                                              )
                                            },
                                            dragover: function ($event) {
                                              $event.preventDefault()
                                              return _vm.handleDragOver(
                                                $event,
                                                item
                                              )
                                            },
                                            dragenter: function ($event) {
                                              return _vm.handleDragEnter(
                                                $event,
                                                item
                                              )
                                            },
                                            dragend: function ($event) {
                                              return _vm.handleDragEnd(
                                                $event,
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("img", { attrs: { src: item } }),
                                          _vm._v(" "),
                                          !_vm.isDisabled
                                            ? _c("i", {
                                                staticClass:
                                                  "el-icon-error btndel",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleRemove(
                                                      index
                                                    )
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                        ]
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _vm.formValidate.sliderImages.length < 10 &&
                                  !_vm.isDisabled
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "upLoadPicBox",
                                          on: {
                                            click: function ($event) {
                                              return _vm.modalPicTap("2")
                                            },
                                          },
                                        },
                                        [
                                          _c("div", { staticClass: "upLoad" }, [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-camera cameraIconfont",
                                            }),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { xs: 18, sm: 18, md: 18, lg: 12, xl: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "运费模板：", prop: "tempId" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "mr20",
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择",
                                disabled: _vm.isDisabled,
                              },
                              model: {
                                value: _vm.formValidate.tempId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formValidate, "tempId", $$v)
                                },
                                expression: "formValidate.tempId",
                              },
                            },
                            _vm._l(_vm.shippingList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.customConfig.mallType == 1
                    ? _c(
                        "el-col",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: ["admin:product:rule:list"],
                              expression: "['admin:product:rule:list']",
                            },
                          ],
                          attrs: { span: 24 },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "商品规格：", props: "specType" },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  attrs: { disabled: _vm.isDisabled },
                                  on: {
                                    change: function ($event) {
                                      return _vm.onChangeSpec(
                                        _vm.formValidate.specType
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.formValidate.specType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formValidate,
                                        "specType",
                                        $$v
                                      )
                                    },
                                    expression: "formValidate.specType",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio",
                                    {
                                      staticClass: "radio",
                                      attrs: { label: false },
                                    },
                                    [_vm._v("单规格")]
                                  ),
                                  _vm._v(" "),
                                  _c("el-radio", { attrs: { label: true } }, [
                                    _vm._v("多规格"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.formValidate.specType && !_vm.isDisabled
                    ? _c(
                        "el-col",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: ["admin:product:rule:list"],
                              expression: "['admin:product:rule:list']",
                            },
                          ],
                          staticClass: "noForm",
                          attrs: { span: 24 },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "规格模板：", prop: "" } },
                            [
                              _c(
                                "div",
                                { staticClass: "acea-row" },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      model: {
                                        value: _vm.formValidate.selectRule,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formValidate,
                                            "selectRule",
                                            $$v
                                          )
                                        },
                                        expression: "formValidate.selectRule",
                                      },
                                    },
                                    _vm._l(_vm.ruleList, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: item.ruleName,
                                          value: item.id,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "mr20",
                                      attrs: { type: "primary" },
                                      on: { click: _vm.confirm },
                                    },
                                    [_vm._v("确认")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "mr15",
                                      on: { click: _vm.addRule },
                                    },
                                    [_vm._v("创建新模板")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            _vm._l(
                              _vm.formValidate.attr,
                              function (item, index) {
                                return _c("div", { key: index }, [
                                  _c(
                                    "div",
                                    { staticClass: "acea-row row-middle" },
                                    [
                                      _c("span", { staticClass: "mr5" }, [
                                        _vm._v(_vm._s(item.attrName)),
                                      ]),
                                      _vm.customConfig.mallType == 1
                                        ? _c("i", {
                                            staticClass: "el-icon-circle-close",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleRemoveAttr(
                                                  index
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "rulesBox" },
                                    [
                                      _vm._l(
                                        item.attrValue,
                                        function (j, indexn) {
                                          return _c(
                                            "el-tag",
                                            {
                                              key: indexn,
                                              staticClass: "mb5 mr10",
                                              attrs: {
                                                closable: "",
                                                size: "medium",
                                                "disable-transitions": false,
                                              },
                                              on: {
                                                close: function ($event) {
                                                  return _vm.handleClose(
                                                    item.attrValue,
                                                    indexn
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(j) +
                                                  "\n                  "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      _vm._v(" "),
                                      item.inputVisible
                                        ? _c("el-input", {
                                            ref: "saveTagInput",
                                            refInFor: true,
                                            staticClass: "input-new-tag",
                                            attrs: { size: "small" },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.createAttr(
                                                  item.attrValue.attrsVal,
                                                  index
                                                )
                                              },
                                            },
                                            nativeOn: {
                                              keyup: function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                return _vm.createAttr(
                                                  item.attrValue.attrsVal,
                                                  index
                                                )
                                              },
                                            },
                                            model: {
                                              value: item.attrValue.attrsVal,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item.attrValue,
                                                  "attrsVal",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.attrValue.attrsVal",
                                            },
                                          })
                                        : _c(
                                            "el-button",
                                            {
                                              staticClass: "button-new-tag",
                                              attrs: { size: "small" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showInput(item)
                                                },
                                              },
                                            },
                                            [_vm._v("+ 添加")]
                                          ),
                                    ],
                                    2
                                  ),
                                ])
                              }
                            ),
                            0
                          ),
                          _vm._v(" "),
                          _vm.isBtn && _vm.customConfig.mallType == 1
                            ? _c(
                                "el-col",
                                [
                                  _c(
                                    "el-col",
                                    {
                                      attrs: {
                                        xl: 6,
                                        lg: 9,
                                        md: 9,
                                        sm: 24,
                                        xs: 24,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "规格：" } },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              placeholder: "请输入规格",
                                            },
                                            model: {
                                              value: _vm.formDynamic.attrsName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formDynamic,
                                                  "attrsName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formDynamic.attrsName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    {
                                      attrs: {
                                        xl: 6,
                                        lg: 9,
                                        md: 9,
                                        sm: 24,
                                        xs: 24,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "规格值：" } },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              placeholder: "请输入规格值",
                                            },
                                            model: {
                                              value: _vm.formDynamic.attrsVal,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formDynamic,
                                                  "attrsVal",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formDynamic.attrsVal",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    {
                                      attrs: {
                                        xl: 12,
                                        lg: 6,
                                        md: 6,
                                        sm: 24,
                                        xs: 24,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-form-item",
                                        { staticClass: "noLeft" },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "mr15",
                                              attrs: { type: "primary" },
                                              on: { click: _vm.createAttrName },
                                            },
                                            [_vm._v("确定")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-button",
                                            { on: { click: _vm.offAttrName } },
                                            [_vm._v("取消")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isBtn && _vm.customConfig.mallType == 1
                            ? _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "mr15",
                                      attrs: {
                                        type: "primary",
                                        icon: "md-add",
                                      },
                                      on: { click: _vm.addBtn },
                                    },
                                    [_vm._v("添加新规格")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.formValidate.attr.length > 0 &&
                  _vm.formValidate.specType &&
                  !_vm.isDisabled &&
                  _vm.customConfig.mallType == 1
                    ? _c(
                        "el-col",
                        { staticClass: "noForm", attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "批量设置：" } },
                            [
                              _c(
                                "el-table",
                                {
                                  staticClass: "tabNumWidth",
                                  attrs: {
                                    border: true,
                                    data: _vm.oneFormBatch,
                                    border: "",
                                    size: "mini",
                                  },
                                },
                                [
                                  _vm.customConfig.mallType == 1
                                    ? _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "图片",
                                          "min-width": "80",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "upLoadPicBox",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.modalPicTap(
                                                            "1",
                                                            "pi"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      scope.row.image
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "pictrue tabPic",
                                                            },
                                                            [
                                                              _c("img", {
                                                                attrs: {
                                                                  src: scope.row
                                                                    .image,
                                                                },
                                                              }),
                                                            ]
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "upLoad tabPic",
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "el-icon-camera cameraIconfont",
                                                              }),
                                                            ]
                                                          ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1369417214
                                        ),
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.bizType == 2
                                    ? [
                                        _c("el-table-column", {
                                          attrs: {
                                            align: "center",
                                            label: "兑换积分现价",
                                            "min-width": "120",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _c("el-input", {
                                                      staticClass: "priceBox",
                                                      attrs: {
                                                        type: "number",
                                                        min: 0,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.pointsPrice,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "pointsPrice",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.pointsPrice",
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            2879904350
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            align: "center",
                                            label: "兑换积分原价",
                                            "min-width": "120",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _c("el-input", {
                                                      staticClass: "priceBox",
                                                      attrs: {
                                                        type: "number",
                                                        min: 0,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row
                                                            .pointsOtPrice,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "pointsOtPrice",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.pointsOtPrice",
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            209265189
                                          ),
                                        }),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._l(_vm.attrValue, function (item, iii) {
                                    return _c("el-table-column", {
                                      key: iii,
                                      attrs: {
                                        label: _vm.formThead[iii].title,
                                        align: "center",
                                        "min-width": "120",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c("el-input", {
                                                  staticClass: "priceBox",
                                                  attrs: {
                                                    maxlength: "9",
                                                    min: "0.01",
                                                  },
                                                  on: {
                                                    blur: function ($event) {
                                                      return _vm.keyupEvent(
                                                        iii,
                                                        scope.row[iii],
                                                        scope.$index,
                                                        1
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: scope.row[iii],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        iii,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row[iii]",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    })
                                  }),
                                  _vm._v(" "),
                                  _vm.formValidate.isSub && _vm.bizType == 1
                                    ? [
                                        _c("el-table-column", {
                                          attrs: {
                                            align: "center",
                                            label: "一级返佣(元)",
                                            "min-width": "120",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _c("el-input", {
                                                      staticClass: "priceBox",
                                                      attrs: {
                                                        type: "number",
                                                        min: 0,
                                                        max: scope.row.price,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.brokerage,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "brokerage",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.brokerage",
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            99765219
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            align: "center",
                                            label: "二级返佣(元)",
                                            "min-width": "120",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _c("el-input", {
                                                      staticClass: "priceBox",
                                                      attrs: {
                                                        type: "number",
                                                        min: 0,
                                                        max: scope.row.price,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row
                                                            .brokerageTwo,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "brokerageTwo",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.brokerageTwo",
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            1573915567
                                          ),
                                        }),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "el-table-column",
                                    {
                                      attrs: {
                                        align: "center",
                                        label: "操作",
                                        "min-width": "80",
                                      },
                                    },
                                    [
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "submission",
                                            attrs: { type: "text" },
                                            on: { click: _vm.batchAdd },
                                          },
                                          [_vm._v("批量添加")]
                                        ),
                                      ],
                                    ],
                                    2
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { xl: 24, lg: 24, md: 24, sm: 24, xs: 24 } },
                    [
                      (_vm.customConfig.mallType == 1 &&
                        _vm.formValidate.specType === false) ||
                      (_vm.customConfig.mallType == 2 &&
                        _vm.printInputType == 2)
                        ? _c(
                            "el-form-item",
                            [
                              _c(
                                "el-table",
                                {
                                  staticClass: "tabNumWidth",
                                  attrs: {
                                    border: true,
                                    data: _vm.OneattrValue,
                                    border: "",
                                    size: "mini",
                                  },
                                },
                                [
                                  _vm.customConfig.mallType == 1
                                    ? _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "图片",
                                          "min-width": "80",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "upLoadPicBox",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.modalPicTap(
                                                            "1",
                                                            "dan",
                                                            "pi"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm.formValidate.image
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "pictrue tabPic",
                                                            },
                                                            [
                                                              _c("img", {
                                                                attrs: {
                                                                  src: scope.row
                                                                    .image,
                                                                },
                                                              }),
                                                            ]
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "upLoad tabPic",
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "el-icon-camera cameraIconfont",
                                                              }),
                                                            ]
                                                          ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1357914119
                                        ),
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.bizType == 2
                                    ? [
                                        _c("el-table-column", {
                                          attrs: {
                                            align: "center",
                                            label: "兑换积分现价",
                                            "min-width": "120",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _c("el-input", {
                                                      staticClass: "priceBox",
                                                      attrs: {
                                                        type: "number",
                                                        min: 0,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.pointsPrice,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "pointsPrice",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.pointsPrice",
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            2879904350
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            align: "center",
                                            label: "兑换积分原价",
                                            "min-width": "120",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _c("el-input", {
                                                      staticClass: "priceBox",
                                                      attrs: {
                                                        type: "number",
                                                        min: 0,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row
                                                            .pointsOtPrice,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "pointsOtPrice",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.pointsOtPrice",
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            209265189
                                          ),
                                        }),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._l(_vm.attrValue, function (item, iii) {
                                    return _c(
                                      "el-table-column",
                                      {
                                        key: iii,
                                        attrs: {
                                          align: "center",
                                          "min-width": "120",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-input", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      disabled:
                                                        _vm.isDisabled ||
                                                        (iii === "stock" &&
                                                          scope.row["id"] &&
                                                          scope.row["id"] !=
                                                            "" &&
                                                          scope.row["id"] !=
                                                            null),
                                                      maxlength: "9",
                                                      min: "0.01",
                                                    },
                                                    on: {
                                                      blur: function ($event) {
                                                        return _vm.keyupEvent(
                                                          iii,
                                                          scope.row[iii],
                                                          scope.$index,
                                                          2
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: scope.row[iii],
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          iii,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row[iii]",
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c(
                                          "template",
                                          { slot: "header" },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.formThead[iii].title)
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            iii === "stock"
                                              ? _c(
                                                  "el-tooltip",
                                                  {
                                                    attrs: {
                                                      effect: "dark",
                                                      content:
                                                        "如果修改库存，请去商品列表-仓库中-‘库存调整’按钮进行操作",
                                                      placement: "top",
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-question",
                                                      staticStyle: {
                                                        "margin-left": "5px",
                                                        cursor: "pointer",
                                                      },
                                                    }),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      2
                                    )
                                  }),
                                  _vm._v(" "),
                                  _vm.formValidate.isSub && _vm.bizType == 1
                                    ? [
                                        _c("el-table-column", {
                                          attrs: {
                                            align: "center",
                                            label: "一级返佣(元)",
                                            "min-width": "120",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _c("el-input", {
                                                      staticClass: "priceBox",
                                                      attrs: {
                                                        disabled:
                                                          _vm.isDisabled,
                                                        type: "number",
                                                        min: 0,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.brokerage,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "brokerage",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.brokerage",
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            3549059968
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            align: "center",
                                            label: "二级返佣(元)",
                                            "min-width": "120",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _c("el-input", {
                                                      staticClass: "priceBox",
                                                      attrs: {
                                                        disabled:
                                                          _vm.isDisabled,
                                                        type: "number",
                                                        min: 0,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row
                                                            .brokerageTwo,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "brokerageTwo",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.brokerageTwo",
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            342384460
                                          ),
                                        }),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$route.params.id && _vm.showAll
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "全部sku：" } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "default",
                                    disabled: _vm.isDisabled,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showAllSku()
                                    },
                                  },
                                },
                                [_vm._v("展示")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      (_vm.customConfig.mallType == 1 &&
                        _vm.formValidate.attr.length > 0 &&
                        _vm.formValidate.specType) ||
                      (_vm.customConfig.mallType == 2 &&
                        _vm.printInputType == 1 &&
                        _vm.formValidate.attr.length > 0 &&
                        _vm.formValidate.specType)
                        ? _c(
                            "el-form-item",
                            {
                              staticClass: "labeltop",
                              class: _vm.isDisabled
                                ? "disLabel"
                                : "disLabelmoren",
                              attrs: { label: "商品属性：" },
                            },
                            [
                              _c(
                                "el-table",
                                {
                                  staticClass: "tabNumWidth",
                                  attrs: {
                                    border: true,
                                    data: _vm.ManyAttrValue,
                                    border: "",
                                    size: "mini",
                                  },
                                },
                                [
                                  _vm.manyTabDate
                                    ? _vm._l(
                                        _vm.manyTabDate,
                                        function (item, iii) {
                                          return _c("el-table-column", {
                                            key: iii,
                                            attrs: {
                                              align: "center",
                                              label: _vm.manyTabTit[iii].title,
                                              "min-width": "80",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("span", {
                                                        staticClass: "priceBox",
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            scope.row[iii]
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          })
                                        }
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.customConfig.mallType == 1
                                    ? _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "图片",
                                          "min-width": "80",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "upLoadPicBox",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.modalPicTap(
                                                            "1",
                                                            "duo",
                                                            scope.$index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      scope.row.image
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "pictrue tabPic",
                                                            },
                                                            [
                                                              _c("img", {
                                                                attrs: {
                                                                  src: scope.row
                                                                    .image,
                                                                },
                                                              }),
                                                            ]
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "upLoad tabPic",
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "el-icon-camera cameraIconfont",
                                                              }),
                                                            ]
                                                          ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3478746955
                                        ),
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.bizType == 2
                                    ? [
                                        _c("el-table-column", {
                                          attrs: {
                                            align: "center",
                                            label: "兑换积分现价",
                                            "min-width": "120",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _c("el-input", {
                                                      staticClass: "priceBox",
                                                      attrs: {
                                                        type: "number",
                                                        min: 0,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.pointsPrice,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "pointsPrice",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.pointsPrice",
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            2879904350
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            align: "center",
                                            label: "兑换积分原价",
                                            "min-width": "120",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _c("el-input", {
                                                      staticClass: "priceBox",
                                                      attrs: {
                                                        type: "number",
                                                        min: 0,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row
                                                            .pointsOtPrice,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "pointsOtPrice",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.pointsOtPrice",
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            209265189
                                          ),
                                        }),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._l(_vm.attrValue, function (item, iii) {
                                    return _c(
                                      "el-table-column",
                                      {
                                        key: iii,
                                        attrs: {
                                          align: "center",
                                          "min-width": "120",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-input", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      disabled:
                                                        _vm.isDisabled ||
                                                        (iii === "stock" &&
                                                          scope.row["id"] &&
                                                          scope.row["id"] !=
                                                            "" &&
                                                          scope.row["id"] !=
                                                            null),
                                                      maxlength: "9",
                                                      min: "0.01",
                                                    },
                                                    on: {
                                                      blur: function ($event) {
                                                        return _vm.keyupEvent(
                                                          iii,
                                                          scope.row[iii],
                                                          scope.$index,
                                                          3
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: scope.row[iii],
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          iii,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row[iii]",
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c(
                                          "template",
                                          { slot: "header" },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.formThead[iii].title)
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            iii === "stock"
                                              ? _c(
                                                  "el-tooltip",
                                                  {
                                                    attrs: {
                                                      content:
                                                        "如果修改库存，请去商品列表-仓库中-'库存调整'按钮进行操作",
                                                      placement: "top",
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-question",
                                                      staticStyle: {
                                                        "margin-left": "5px",
                                                        cursor: "pointer",
                                                      },
                                                    }),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      2
                                    )
                                  }),
                                  _vm._v(" "),
                                  _vm.formValidate.isSub && _vm.bizType == 1
                                    ? _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "一级返佣(元)",
                                          "min-width": "120",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-input", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      disabled: _vm.isDisabled,
                                                      type: "number",
                                                      min: 0,
                                                      max: scope.row.price,
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.brokerage,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "brokerage",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.brokerage",
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2857277871
                                        ),
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.formValidate.isSub && _vm.bizType == 1
                                    ? _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          label: "二级返佣(元)",
                                          "min-width": "120",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-input", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      disabled: _vm.isDisabled,
                                                      type: "number",
                                                      min: 0,
                                                      max: scope.row.price,
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.brokerageTwo,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "brokerageTwo",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.brokerageTwo",
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3609981283
                                        ),
                                      })
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.customConfig.mallType == 1
                ? _c(
                    "el-row",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentTab === 1 && !_vm.isDisabled,
                          expression: "currentTab === 1 && !isDisabled",
                        },
                      ],
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "商品详情：" } },
                            [
                              _c("Tinymce", {
                                staticStyle: { width: "800px" },
                                model: {
                                  value: _vm.formValidate.content,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formValidate, "content", $$v)
                                  },
                                  expression: "formValidate.content",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab === 1 && _vm.isDisabled,
                      expression: "currentTab === 1 && isDisabled",
                    },
                  ],
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("el-form-item", { attrs: { label: "商品详情：" } }, [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(_vm.formValidate.content || "无"),
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab === 2 || !_vm.stepInput,
                      expression: "currentTab === 2||!stepInput",
                    },
                  ],
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        _vm._b({}, "el-col", _vm.grid, false),
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "排序：" } },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  min: 0,
                                  placeholder: "请输入排序",
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value: _vm.formValidate.sort,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formValidate, "sort", $$v)
                                  },
                                  expression: "formValidate.sort",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.customConfig.enableGoodsPoints == 1
                        ? _c(
                            "el-col",
                            _vm._b({}, "el-col", _vm.grid, false),
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "积分：" } },
                                [
                                  _c("el-input-number", {
                                    attrs: {
                                      min: 0,
                                      placeholder: "请输入积分",
                                      disabled: _vm.isDisabled,
                                    },
                                    model: {
                                      value: _vm.formValidate.giveIntegral,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formValidate,
                                          "giveIntegral",
                                          $$v
                                        )
                                      },
                                      expression: "formValidate.giveIntegral",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        _vm._b({}, "el-col", _vm.grid, false),
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "虚拟销量：" } },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  min: 0,
                                  placeholder: "请输入排序",
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value: _vm.formValidate.ficti,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formValidate, "ficti", $$v)
                                  },
                                  expression: "formValidate.ficti",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品推荐：" } },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              attrs: {
                                size: "small",
                                disabled: _vm.isDisabled,
                              },
                              on: { change: _vm.onChangeGroup },
                              model: {
                                value: _vm.checkboxGroup,
                                callback: function ($$v) {
                                  _vm.checkboxGroup = $$v
                                },
                                expression: "checkboxGroup",
                              },
                            },
                            _vm._l(_vm.recommend, function (item, index) {
                              return _c(
                                "el-checkbox",
                                { key: index, attrs: { label: item.value } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.stepInput
                ? _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.currentTab > 0,
                              expression: "currentTab>0",
                            },
                          ],
                          staticClass: "submission priamry_border",
                          on: { click: _vm.handleSubmitUp },
                        },
                        [_vm._v("上一步")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.currentTab < 2,
                              expression: "currentTab<2",
                            },
                          ],
                          staticClass: "submission",
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.handleSubmitNest("formValidate")
                            },
                          },
                        },
                        [_vm._v("下一步")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                (_vm.currentTab === 2 ||
                                  _vm.$route.params.id) &&
                                !_vm.isDisabled,
                              expression:
                                "(currentTab===2 || $route.params.id) && !isDisabled",
                            },
                          ],
                          staticClass: "submission",
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.handleSubmit("formValidate")
                            },
                          },
                        },
                        [_vm._v("提交")]
                      ),
                    ],
                    1
                  )
                : _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                (!_vm.currentTab || _vm.$route.params.id) &&
                                !_vm.isDisabled,
                              expression:
                                "(!currentTab ||$route.params.id) && !isDisabled",
                            },
                          ],
                          staticClass: "submission",
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.handleSubmit("formValidate")
                            },
                          },
                        },
                        [_vm._v("提交")]
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("CreatTemplates", {
        ref: "addTemplates",
        on: { getList: _vm.getShippingList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }